import type { UserSimpleModel } from "api";
import { rolesEnum, userStatesEnum } from "helpers/enums";
import { containsQuery } from "helpers/reqparams";
import { ITEM_ROOT } from "odata-query";
import { request } from "services/request";

const resource = "api/employees";
const organizationEmployeesResource = "api/organizationEmployees";

const list = (params: {}) => request(`${resource}/GetNamesList${containsQuery(params)}`, { method: "GET" });

const listSalesManagers = (params: {}) => {
    const filter = {
        Roles: {
            any: {
                [ITEM_ROOT]: {
                    in: [rolesEnum.TruckingOrganizationManager, rolesEnum.TruckingOrganizationHeadLogist],
                },
            },
        },
    };
    return request(`${resource}/GetNamesByRolesList${containsQuery(params, { filter })}`, { method: "GET" });
};

const adminsList = (params: {}) => {
    const filter = {
        Roles: {
            any: {
                [ITEM_ROOT]: {
                    in: [rolesEnum.TruckingOrganizationAdmin],
                },
            },
        },
    };
    return request(`${resource}/GetNamesByRolesList${containsQuery(params, { filter })}`, { method: "GET" });
};

const validAdminsList = (params: {}) => {
    const filter = {
        and: [
            {
                RoleTypes: {
                    any: {
                        [ITEM_ROOT]: {
                            in: [rolesEnum.TruckingOrganizationAdmin],
                        },
                    },
                },
            },
            { State: userStatesEnum.Valid },
        ],
    };
    return request(`${organizationEmployeesResource}/getList${containsQuery(params, { filter })}`, {
        method: "GET",
    }).then((users: UserSimpleModel[]) =>
        users.map((user) => ({ ...user, fullNameOrEmail: user.fullName || user.email })),
    );
};

const overallMailReportUsersList = (params: {}) => {
    const filter = {
        and: [
            {
                Roles: {
                    any: {
                        [ITEM_ROOT]: {
                            in: [rolesEnum.TruckingOrganizationAdmin, rolesEnum.TruckingOrganizationHeadLogist],
                        },
                    },
                },
            },
            {
                not: {
                    Roles: {
                        any: {
                            [ITEM_ROOT]: rolesEnum.IntegrationAccount,
                        },
                    },
                },
            },
        ],
    };
    return request(`${resource}/GetNamesByRolesList${containsQuery(params, { filter })}`, { method: "GET" });
};

export { list, listSalesManagers, adminsList, validAdminsList, overallMailReportUsersList };
